export default __webpack_public_path__ + "static/media/chips.1b21b497.gif";